import { AppBackdrop } from '@/shared/ui/appBackdrop'
import { useStyles } from './styles'
import { Icon } from '@/shared/ui/icon'
import { useUnit } from 'effector-react'
import { $userLanguage } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import { AppButton } from '@/shared/ui/button'

type PlayGameModalProps = {
  onConfirm: () => void
  onCancel: () => void
}

export const PlayGameModal = (props: PlayGameModalProps) => {
  const { classes } = useStyles()
  const { onConfirm, onCancel } = props
  const userLang = useUnit($userLanguage)
  const text = lang[userLang].pages.tasks.modalText
  const buttonTexts = lang[userLang].pages.btnTexts

  return (
    <div className={classes.wrapper}>
      <div className={classes.root}>
        <div className={classes.textContainer}>
          <Icon
            view="whiteAlert"
            width={40}
            style={{ filter: 'brightness(1000%) contrast(100%)', alignSelf: 'center' }}
          />
          <span>{text}</span>
        </div>
        <div className={classes.buttonContainer}>
          <AppButton
            onClick={onConfirm}
            className={classes.confirmButton}
          >
            <span>{buttonTexts.updateProgress}</span>
          </AppButton>
          <AppButton
            onClick={onCancel}
            className={classes.cancelButton}
          >
            <span>{buttonTexts.close}</span>
          </AppButton>
        </div>
      </div>
      <AppBackdrop
        styles={{ height: '100%', zIndex: '5' }}
        onClick={onCancel}
      />
    </div>
  )
}
